module.exports = __webpack_public_path__ + "img/vcontroller-show-btn2.00b65533.png";